import { tv } from '@change/ds-utils';

export const sectionContainer = tv({
	base: 'mt-12 flex flex-col gap-2',
});

export const titleContainer = tv({
	base: 'flex flex-col gap-2',
});

export const descriptionContainer = tv({
	base: 'mb-5 flex flex-col gap-2',
});

export const endorsementCardContainer = tv({
	base: 'flex flex-col gap-5',
});

export const actionButtonsContainer = tv({
	base: 'mt-6 flex items-center gap-4',
});

export const actionButtonsContainerEmptyState = tv({
	base: 'flex items-center gap-4',
});
